// TreeNode.js
import React, { useState, useEffect } from "react";
import { DownIcon, UpIcon } from "../../../component/icons/icons";
import { IconButton, ListItem, ListItemText } from "@mui/material";
import {styled, alpha } from "@mui/material/styles";
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles ((theme) => ({
//     root: {
//         padding: 0,
//     },
//     listItem: {
//         borderRadius: 6,
//         transition: 'background-color 0.2s ease',
//         '&:hover': {
//           backgroundColor: (props) => alpha(props.themeColor, 0.12),
//           color: (props) => props.themeColor,
//         },
//       },
//       selected: {
//         borderRadius: '0px 6px 6px 0px',
//         borderLeft: (props) => `2px solid ${props.themeColor}`,
//         fontWeight: 'bold',
//         color: (props) => props.themeColor,
//         '&:hover': {
//           backgroundColor: (props) => alpha(props.themeColor, 0.12)
//         },
//       },
// }));

const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'themeColor' && prop !== 'selected',
})(({ theme, themeColor, selected }) => ({
  borderRadius: selected ? '0px 6px 6px 0px' : 6,
  transition: 'background-color 0.2s ease',
  fontWeight: selected ? 'bold' : 'normal',
  color: selected ? themeColor : 'inherit',
  borderLeft: selected ? `2px solid ${themeColor}` : 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(themeColor || theme.palette.primary.main, 0.12),
    color: themeColor || theme.palette.primary.main,
  },
}));

const TreeNode = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  // const classes = useStyles({ themeColor: props.tenantData.color });

  useEffect(() => {
    setIsCollapsed(!isActiveTab());
  }, [props.activeTabId, props.subTabValue, props.index, props.subTab]);

  const handleToggle = () => {
    isActiveTab() ? setIsCollapsed(false) : setIsCollapsed((prev) => !prev);
  };

  const isLeaf =
    !props.node.subCategories || props.node.subCategories.length === 0;
  const hasLeaf =
    props.node.subCategories &&
    (!props.node.subCategories[0].subCategories ||
      !props.node.subCategories[0].subCategories.length === 0);

  const showLeafNodes = () => {
    if (props.mode === "auxTab") {
      props.switchAuxTab(props.node, props.index);
    } else {
      if (isLeaf) {
        props.setLeafNode(props.node, props.index);
      } else if (hasLeaf && props.node.subCategories.length > 0) {
        props.setLeafNodes(
          props.node.subCategories,
          props.index,
          props.subTab ? props.subTab : 0,
        );
      } else {
        handleToggle();
        if (props.node.subCategories && props.node.subCategories.length > 0) {
          if (
            props.node.subCategories[0].subCategories &&
            props.node.subCategories[0].subCategories.length > 0
          ) {
            props.setLeafNodes(
              props.node.subCategories[0].subCategories,
              props.index,
              props.subTab ? props.subTab : 0,
            );
          }
        }
      }
    }
  };

  const isActiveTab = () => {
    if (props.level === 0) {
      return props.activeTabId === props.index;
    } else {
      return (
        props.activeTabId === props.index &&
        props.subTab !== undefined &&
        props.subTab === props.subTabValue
      );
    }
  };

  return (
    <div style={{ marginLeft: props.level === 0 ? 0 : 20 }}>
      <StyledListItem
        button
        key={props.node.id}
        onClick={showLeafNodes}
        themeColor={props.tenantData.color} selected={isActiveTab()}
        // classes={{ root: isActiveTab() ? classes.selected : classes.listItem }}
        // style={{
        //     borderLeft: isActiveTab() ? `2px solid ${props.tenantData.color}` : `2px solid white`,
        //     fontWeight: isActiveTab() ? 'bold' : 'normal',
        // 	display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '0px', paddingBottom: '0px'
        // }}
      >
        <ListItemText
          // style={{ color: isActiveTab() ? props.tenantData.color : "inherit" }}
          primary={props.node.name}
          // secondary={`${props.index}-${props.subTab}//${props.activeTabId}-${props.subTabValue}`}
        />
        {/* {!(isLeaf || hasLeaf) && props.node.subCategories && props.node.subCategories.length > 0 && (
                        <IconButton onClick={handleToggle} style={{color: isActiveTab() ? props.tenantData.color : "inherit"}}>{isCollapsed ? <DownIcon/> : <UpIcon/>}</IconButton>
                    )} */}
      </StyledListItem>

      {!isCollapsed &&
        props.node.subCategories &&
        props.node.subCategories.length > 0 && (
          <div>
            {!(isLeaf || hasLeaf) &&
              props.node.subCategories.map((subNode, idx) => (
                <TreeNode
                  key={subNode.id}
                  node={subNode}
                  level={props.level + 1}
                  setLeafNodes={props.setLeafNodes}
                  index={props.index}
                  subTab={idx}
                  setLeafNode={props.setLeafNode}
                  tenantData={props.tenantData}
                  activeTabId={props.activeTabId}
                  subTabValue={props.subTabValue}
                />
              ))}
          </div>
        )}
    </div>
  );
};

export default TreeNode;
